import { createUseStyles } from 'react-jss';

const styles = {
  headerBlock: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '3rem',
  },
  infoHeader: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4rem',
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginBottom: '8rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
